import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '../views/HomeView.vue';
import LibView from '../views/LibView.vue';
import LkView from '../views/LkView.vue';
import CategoryView from '../views/CategoryView.vue';

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/lib',
    name: 'lib',
    component: LibView,
  },
  {
    path: '/category/:id',
    name: 'category',
    component: CategoryView,
  },
  {
    path: '/lk',
    name: 'lk',
    component: LkView,
  },
];

const router = createRouter({
  history: createWebHistory(),
  linkActiveClass: 'active',
  routes,
});

export default router;
